import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { ButtonLooks } from '../../../../enums/button.js';
import { FontIcons } from '../../../../enums/font-icon.js';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import { iconButtonStyle, getButtonTheme } from '../../../../styles/styled-components/button.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import '../../../../styles/styled-components/listitem.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import '../../../../styles/styled-components/tooltip.js';
import { FontIcon } from '../../icon/font-icon/font-icon.js';
import { BaseButton } from '../base-button/base-button.js';

const BaseCloseButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { 'aria-label': ariaLabel, className, disabled, fontIconProps, icon, look, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseButton, {
        ...otherProps,
        "aria-label": ariaLabel,
        className: classnames({
            'bf-button__close': true,
            'bf-button__close--disabled': disabled,
            [`bf-button__close--look-${look}`]: look,
            [`${className}`]: className
        }),
        disabled: disabled,
        ref: ref
    }, /*#__PURE__*/ React.createElement(FontIcon, {
        ...fontIconProps,
        className: classnames({
            'bf-button__close-icon': true,
            [`${fontIconProps?.className}`]: fontIconProps?.className
        }),
        icon: icon || FontIcons.Close
    }));
});
const Button = styled(BaseCloseButton)`
  ${iconButtonStyle}
  ${({ look })=>getButtonTheme({
        look
    })}

  .bf-button__close-icon {
    font-size: 16px;
  }
`;
const CloseButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { look = ButtonLooks.Default, ...otherProps } = props;
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Button, {
        ...otherProps,
        look: look,
        ref: ref
    }));
});

export { BaseCloseButton, CloseButton };
//# sourceMappingURL=close-button.js.map
